import React from 'react';
import { disciplines } from '../data/hero';
import { phases, tools } from '../data/system';
export function SystemOverview() {
  return <section aria-label="Aperçu du système" className="bg-navy text-white" data-id="element-285" data-mp="18v0mymbbl32b">
      <div className="mx-auto max-w-6xl px-5 py-14 lg:py-20" style={{
      paddingTop: "20px",
      paddingBottom: "22px"
    }} data-id="element-286" data-mp="1mlmbaqjjm57l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-287" data-mp="1ho487gs7ik7i">
          <h2 className="font-display text-3xl font-extrabold uppercase leading-none sm:text-5xl" data-id="element-288" data-mp="txgo7x50o44l">
            Le système complet pour préparer votre triathlon distance complète
          </h2>
          <p className="mt-4 text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-289" data-mp="13vwbtq4u4v9c">
            Le système complet pour les athlètes qui ne veulent plus assembler leur préparation à partir de
            séances isolées, de conseils contradictoires et d'innombrables ressources dispersées.
          </p>
          <p className="mt-5 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 text-sm font-semibold uppercase tracking-wider text-white" data-id="element-290" data-mp="2acrnmvq9yfd5">
            {disciplines.map((d, i) => <React.Fragment key={d} data-id="element-291" data-mp="285gyxiw7qrhb" data-mpi={i}>
                {i > 0 && <span className="text-aqua" aria-hidden="true" data-id="element-292" data-mp="2845vxlaldnr9">·</span>}
                <span data-id="element-293" data-mp="2d40nzs63sjdw">{d}</span>
              </React.Fragment>)}
          </p>
          <p className="mt-3 text-sm text-white/50" data-id="element-294" data-mp="2i3mznx6a9rkl">Tout ce dont vous avez besoin dans une offre complète</p>
        </div>

        <p className="mt-12 text-center text-xs font-bold uppercase tracking-[0.25em] text-aqua" data-id="element-295" data-mp="1kgeigedbf4oe">
          Un système · 6 volumes · 4 outils pratiques
        </p>

        <ol className="relative mt-8 grid gap-5 lg:grid-cols-6 lg:gap-4" data-id="element-296" data-mp="1pcmtpgoe6dqa">
          <span aria-hidden="true" className="absolute bottom-3 left-[17px] top-3 w-px bg-electric/50 lg:bottom-auto lg:left-[18px] lg:right-[18px] lg:top-[17px] lg:h-px lg:w-auto" data-id="element-297" data-mp="1uchmxqvn3fei" />
          {phases.map((p, i) => <li key={p.n} className="relative flex items-start gap-4 text-left lg:flex-col lg:gap-3" data-id="element-298" data-mp="11p4y1a20avi1" data-mpi={i}>
              <span className={i === phases.length - 1 ? 'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-electric font-display text-sm font-bold text-white' : 'relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-electric bg-navy font-display text-sm font-bold text-white'} data-id="element-299" data-mp="16mnb9cn23wvu">
                {p.n}
              </span>
              <div data-id="element-300" data-mp="13ftnw279mltj">
                <p className="font-display text-xl font-bold uppercase leading-tight" data-id="element-301" data-mp="13glhj7hay9h6">{p.name}</p>
                <p className="mt-0.5 text-sm leading-snug text-white/60" data-id="element-302" data-mp="fp686ur3yrwf">{p.short}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-12 border-t border-white/10 pt-8" data-id="element-303" data-mp="pmu7zz3kmplg">
          <p className="text-center text-xs font-bold uppercase tracking-[0.25em] text-white/50" data-id="element-304" data-mp="poey9ciurmdi">
            Plus 4 outils pratiques
          </p>
          <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-6 lg:grid-cols-4" data-id="element-305" data-mp="211r6s0pk4t60">
            {tools.map(({
            verb,
            name,
            icon: Icon
          }) => <li key={verb} className="flex items-start gap-3" data-id="element-306" data-mp="1w5aagj87f8hu">
                <Icon className="mt-0.5 h-5 w-5 shrink-0 text-aqua" aria-hidden="true" data-id="element-307" data-mp="23lnomvw8ywm5" />
                <div className="min-w-0" data-id="element-308" data-mp="28m1se1qtfked">
                  <p className="font-display text-lg font-bold uppercase leading-none text-white" data-id="element-309" data-mp="28jp291awm3q8">{verb}</p>
                  <p className="mt-1 text-xs leading-snug text-white/60" data-id="element-310" data-mp="1uod92yceclbf">{name}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}